import { render, staticRenderFns } from "./SlGroupedOfferUpdate.vue?vue&type=template&id=7bba8c6f&lang=pug&"
import script from "./SlGroupedOfferUpdate.vue?vue&type=script&lang=js&"
export * from "./SlGroupedOfferUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SlGroupedOfferUpdate.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
